export default {
  'account': 'Account',
  'kyc-title': 'KYC • Know your customer',
  'connect-to-yoti': 'Connect to Yoti',
  'kyc-description': 'To receive your HVT rewards, we must verifiy your identity. We use a service called {kyc-provider} for this. Click the button to find out more and proceed with creating and connecting your account',
  'kyc-description_step_step_guide': 'please follow our step-by step instructions'
}



// WEBPACK FOOTER //
// ./src/i18n/en/settings.js